import Immutable from 'immutable';
import ConfigTypes from '~/constants/types/ConfigTypes';

export function initialState() {
  return Immutable.Map({
    cartMode: false,
    exitWarningEligible: true,
    clipartRecoloringOverride: null,
    sleevePrintOverride: null,
    streamlinedMobileMode: false,
    streamlinedMobileIntent: null,
    cartCookie: {
      email: '',
      postalCode: '',
      orderItemCount: 0
    },
    lastSaved: null
  });
}

export default function config(state = initialState(), action) {
  switch (action.type) {
    case ConfigTypes.UPDATE_CART_COOKIE: {
      return state.set('cartCookie', action.payload);
    }
    case ConfigTypes.UPDATE_LAST_SAVED: {
      return state.set('lastSaved', action.payload);
    }
    case ConfigTypes.UPDATE_LAB_EXIT_WARNING_ELIGIBILITY: {
      return state.set('exitWarningEligible', action.payload);
    }
    case ConfigTypes.UPDATE_STREAMLINED_MOBILE_MODE: {
      return state.set('streamlinedMobileMode', action.payload);
    }
    case ConfigTypes.UPDATE_STREAMLINED_MOBILE_INTENT: {
      return state.set('streamlinedMobileIntent', action.payload);
    }
    case ConfigTypes.SET_CLIPART_RECOLORING: {
      return state.set('clipartRecoloringOverride', action.payload);
    }
    case ConfigTypes.SET_SLEEVE_PRINT_OVERRIDE: {
      return state.set('sleevePrintOverride', action.payload);
    }
    case ConfigTypes.UPDATE_CART_MODE: {
      return state.set('cartMode', action.payload);
    }
    default:
      return state;
  }
}
